import React, { useEffect, useRef } from "react";
import { Button, Modal, Form as BTForm } from "react-bootstrap";
import axios from "src/config/axios";
import { Form, Formik } from "formik";
import FormPriceInput from "src/components/Forms/FormPriceInput";
import { useState } from "react";
import FormInputText from "src/components/Forms/FormInputText";

const EditPayPerUseProductDialog = ({
  toggle,
  payPerUsePrice = {},
  handleSuccess,
}) => {
  const formRef = useRef();

  function handleSubmit(values, helpers) {
    helpers.setSubmitting(true);

    const payload = {
      ...values,
      duration_in_seconds: Math.max(
        0,
        Math.round((Number(values.duration_in_minutes) || 0) * 60)
      ),
    };
    delete payload.duration_in_minutes;

    let request;

    if (payload.id) {
      request = axios.put(`/api/v1/pay_per_use_products/${values.id}.json`, {
        pay_per_use_product: payload,
      });
    } else {
      request = axios.post(`/api/v1/pay_per_use_products.json`, {
        pay_per_use_product: payload,
      });
    }

    request
      .then(function () {
        handleSuccess();
      })
      .catch(function (e) {
        helpers.setErrors(e.response.data);
      });
  }

  return (
    <Modal show={true} onHide={toggle}>
      <Formik
        innerRef={formRef}
        initialValues={{
          name: payPerUsePrice.name ?? "",
          duration_in_minutes: payPerUsePrice.display_duration_in_minutes,
          price: payPerUsePrice.price ?? 0,
          id: payPerUsePrice.id,
        }}
        onSubmit={handleSubmit}
      >
        {({ handleSubmit }) => (
          <>
            <Modal.Header>
              <Modal.Title>
                {!payPerUsePrice.id ? "Erstellen" : "Bearbeiten"}
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Form autoComplete="false">
                <FormInputText name={"name"} label={"Name"} />
                <FormInputText
                  name={"duration_in_minutes"}
                  label={"Dauer in Minuten:"}
                  type={"number"}
                  min={0}
                />
                <FormPriceInput
                  name="price"
                  label="Preis"
                  placeholder="0.00"
                  required
                />
              </Form>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={toggle}>
                Schließen
              </Button>
              <Button variant="primary" onClick={handleSubmit}>
                Speichern
              </Button>
            </Modal.Footer>
          </>
        )}
      </Formik>
    </Modal>
  );
};

export default EditPayPerUseProductDialog;
